/**
 * FieldLabel
 *
 * Shared form label: label text, optional required asterisk, and an optional
 * help `?` tooltip surfaced from a field definition's `helpText`.
 */

import * as React from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { Tooltip } from './Tooltip';

export interface FieldLabelProps {
  children: React.ReactNode;
  required?: boolean;
  helpText?: string;
  htmlFor?: string;
  /** Overrides the default label classes (matches Input's label block). */
  className?: string;
}

export function FieldLabel({
  children,
  required,
  helpText,
  htmlFor,
  className,
}: FieldLabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      className={className ?? 'block text-sm font-medium text-white/80 mb-2'}
    >
      {children}
      {required && <span className="text-danger-red ml-1">*</span>}
      {helpText && (
        <Tooltip
          content={helpText}
          side="right"
          multiline={helpText.length > 60}
          className="ml-1 inline-flex cursor-help"
        >
          <QuestionMarkCircleIcon
            className="h-3.5 w-3.5 text-text-tertiary"
            aria-hidden="true"
          />
        </Tooltip>
      )}
    </label>
  );
}
